// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import { SET_IS_CONFIRMATION_SHOWN } from 'common/modules/project/constants/types';
import { createCustomAction } from 'typesafe-actions';

export const setIsShown = createCustomAction(
    SET_IS_CONFIRMATION_SHOWN,
    (isShown: boolean) => ({ payload: isShown })
);
